module.exports = __webpack_public_path__ + "img/LeadsIconv3.10627229.png";